var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"user_gallery_list_wrap"},_vm._l((3),function(i){return _c('div',{key:i,staticClass:"user_gallery_list_box",on:{"click":function($event){return _vm.movePage('/gallery')}}},[_c('div',{staticClass:"user_gallery_list_img"}),_vm._m(0,true)])}),0)
}
var staticRenderFns = [function (){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"user_gallery_list_title"},[_c('span',[_vm._v("고양이 사진관")])])
}]

export { render, staticRenderFns }